var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 24.5,
  stroke: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M25.982 19h-4.968v16h4.969v-8.4c0-4.67 6.029-5.051 6.029 0V35H37V24.869c0-7.88-8.922-7.593-11.018-3.714zM13 35h5V19h-5zm4.98-20.5A2.49 2.49 0 0 1 15.5 17a2.49 2.49 0 0 1-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5a2.49 2.49 0 0 1 2.48 2.5"
}))));
export default SvgLinkedin;